import React, { useState } from 'react';
import axios from 'axios';

const ResetPassword = () => {
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [status, setStatus] = useState('idle'); // idle, loading, success, error
  const [message, setMessage] = useState('');

  const params = new URLSearchParams(window.location.search);
  const token = params.get('token');

  const handleSubmit = async () => {
    if (!password || password.length < 6) return setMessage('Password must be at least 6 characters.');
    if (password !== confirm) return setMessage('Passwords do not match.');
    setStatus('loading'); setMessage('');
    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/api/auth/reset-password`, { token, password });
      setStatus('success');
    } catch (err) {
      setStatus('error');
      setMessage(err.response?.data?.error || 'Something went wrong. The link may have expired.');
    }
  };

  const inputStyle = {
    width: '100%', background: '#1a1a1a', border: '1px solid #2a2a2a',
    padding: '14px 16px', color: '#f5f0eb', fontFamily: 'Jost, sans-serif',
    fontSize: '0.85rem', fontWeight: 300, marginBottom: '16px',
    outline: 'none', boxSizing: 'border-box',
  };

  return (
    <div style={{
      minHeight: '100vh', background: '#0a0a0a',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontFamily: 'Jost, sans-serif', padding: '24px',
    }}>
      <div style={{ width: '100%', maxWidth: '440px' }}>
        <p style={{ fontSize: '0.65rem', letterSpacing: '0.4em', textTransform: 'uppercase', color: '#c9a96e', marginBottom: '16px' }}>Flakon</p>

        {status === 'success' ? (
          <>
            <h1 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '2.2rem', fontWeight: 300, color: '#f5f0eb', marginBottom: '16px' }}>Password updated.</h1>
            <p style={{ fontSize: '0.85rem', color: '#6b6460', marginBottom: '32px', lineHeight: 1.7 }}>Your password has been changed successfully. You can now sign in with your new password.</p>
            <a href="/" style={{ display: 'inline-block', background: '#c9a96e', color: '#0a0a0a', textDecoration: 'none', padding: '14px 40px', fontSize: '0.65rem', letterSpacing: '0.2em', textTransform: 'uppercase' }}>Back to Flakon</a>
          </>
        ) : (
          <>
            <h1 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '2.2rem', fontWeight: 300, color: '#f5f0eb', marginBottom: '8px' }}>Choose a new password</h1>
            <p style={{ fontSize: '0.85rem', color: '#6b6460', marginBottom: '32px', lineHeight: 1.7 }}>Must be at least 6 characters.</p>
            {message && <p style={{ color: '#e07070', fontSize: '0.8rem', marginBottom: '16px' }}>{message}</p>}
            <input style={inputStyle} type="password" placeholder="New password" value={password} onChange={e => setPassword(e.target.value)} />
            <input style={inputStyle} type="password" placeholder="Confirm new password" value={confirm} onChange={e => setConfirm(e.target.value)} />
            <button
              onClick={handleSubmit}
              disabled={status === 'loading'}
              style={{ width: '100%', background: '#c9a96e', border: 'none', padding: '16px', color: '#0a0a0a', fontFamily: 'Jost, sans-serif', fontSize: '0.75rem', letterSpacing: '0.2em', textTransform: 'uppercase', cursor: 'pointer', marginTop: '8px' }}
            >
              {status === 'loading' ? 'Updating...' : 'Update Password'}
            </button>
            <a href="/" style={{ display: 'block', textAlign: 'center', marginTop: '20px', fontSize: '0.72rem', color: '#665e58', textDecoration: 'none' }}>← Back to Flakon</a>
          </>
        )}
      </div>
    </div>
  );
};

export default ResetPassword;